<template>
        <v-container fluid class="py-0">
          <v-row >
            <v-col cols=12 class="d-flex justify-end py-0">
              <ImportFicha formTitle="IMPORTAR DATOS" @import="importDatos" />
            </v-col>
            <v-col cols=12 class="my-0 pt-2 pb-2"><v-divider /></v-col>
            <v-col cols=3>
              <v-select
                :items="titulos"
                v-model="frm.titulo"
                label="Dato"
                placeholder="Seleccione un título"
                ref=""
                append-icon="fa fa-angle-down "
                class="caption"
                menu-props="auto"
                clearable
                dense
                hide-details
                return-object
                :disabled="frm.disabled"

                append-outer-icon="fa-refresh"
                @click:append-outer="loadTitulos()"  
              />
            </v-col>
            <template  v-if="frm.titulo">
              <template v-if="frm.titulo.type =='SIMPLE'">
                <v-col cols=1>            
                  <v-text-field v-model="frm.valor1" label="Valor 1" placeholder="Indique un valor"  dense hide-details class="caption" />
                </v-col>
                <v-col cols=1>            
                  <v-text-field v-model="frm.valor2" label="Valor 2" placeholder="Indique un valor"  dense hide-details class="caption" />
                </v-col>
                <v-col cols=1>
                  <v-text-field v-model="frm.valor3" label="Valor 3" placeholder="Indique un valor"  dense hide-details class="caption" />
                </v-col>
                <v-col cols=1>
                  <v-text-field v-model="frm.valor4" label="Valor 4" placeholder="Indique un valor"  dense hide-details class="caption" />
                </v-col>
                <v-col cols=1>
                  <v-text-field v-model="frm.valor5" label="Valor 5" placeholder="Indique un valor"  dense hide-details class="caption" />
                </v-col>
              </template>
              <template v-else-if="frm.titulo.type =='LOGICO'">
                <v-col cols=2>            
                  <v-select 
                    v-model="frm.valor1"
                    :items="['SI','NO']"
                    label="Valor" 
                    placeholder="Indique un valor"  
                    dense 
                    hide-details 
                    class="caption" 
                  />
                </v-col>
              </template>
              <template v-else-if="frm.titulo.type =='MULTIPLE'">
                <v-col cols=3>
                  <v-select 
                    v-model="frm.valor1"
                    :items="itemsTitulos"
                    label="Valor" 
                    placeholder="Indique un valor"  
                    dense 
                    hide-details 
                    class="caption" 
                    return-object

                    append-outer-icon="fa-refresh"
                    @click:append-outer="loadMultiple()"  
                  />
                </v-col>
              </template>
            </template>
            <v-col cols=1 class="text-center"  >
              <v-btn 
                ref="add" 
                x-small 
                class="my-auto mx-0"	
                fab 
                color="primary"	
                @click="addItems()"
                :disabled="!AddItems"
              >
                <v-icon dense>fa fa-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="px-0">
            <v-col cols=12 >
              <v-data-table
                :headers="headers"
                :items="Items"
                class="elevation-2"
                :hide-default-header="true"
                min-height="200px"
                height="300px"
                :fixed-header="true"

                hide-default-footer

                :loading="loadGrid"
              
                :mobile-breakpoint=100

                :items-per-page="999"
              >
                <template v-slot:header="{props}">
                  <thead class="v-data-table-header">
                  <tr >
                      <th
                        role="columnheader" scope="col" :aria-label="header.text" 
                        v-for="header in props.headers"
                        :key="header.text"
                        class="text-truncate body-2 primary white--text "
                        :class="header.class "
                        :align="header.align"
                        :width="header.width"
                        v-text="header.text"
                      />
                  </tr>
                  </thead>
                </template>

                <template v-slot:item="{item,isSelected,select,headers} ">
                  <tr>
                    <template v-for="(h, idx) in headers" >
                      <td v-if="h.value!='actions'" :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                      <td v-else :align="h.align" :key="idx" :class="[ h.class]" class="px-1">
                        <v-icon
                          small
                          class="mx-3"
                          @click="editItem(item)"
                        >
                          fa fa-pencil
                        </v-icon>
                        <v-icon
                          small
                          class="mx-3"
                          @click="removeItem(item)"
                        >
                          fa fa-trash-o
                        </v-icon>
                      </td>
                    </template> 
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'
  import ImportFicha from '@/components/Commond/ImportFicha'

  export default {
    name: 'Titulos',
    props:['items','categoriaID'],

    components: {
      ImportFicha,
    },

    data: () => ({
      loadGrid:false,

      headers: [
        { text: 'D.Técnico',align: 'start' ,sortable: false, value: 'descripcion' },
        { text: 'Valor 1'  ,align: 'start' ,sortable: false, value: 'valor1' },
        { text: 'Valor 2'  ,align: 'start' ,sortable: false, value: 'valor2' },
        { text: 'Valor 3'  ,align: 'start' ,sortable: false, value: 'valor3' },
        { text: 'Valor 4'  ,align: 'start' ,sortable: false, value: 'valor4' },
        { text: 'Valor 5'  ,align: 'start' ,sortable: false, value: 'valor5' },
        { text: ''         ,align: 'center',sortable: false, value: 'actions', width:"85px" },
      ],

      default:{
      },

      editedIndex: -1,
      editedItem :{
      },

      frm:{
      },

      itemsTitulos:[],


      titulos:[]


    }),
    created: function () {
      console.log("Componente creado")

      //console.log(this.categoriaID)
      this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
    },
    watch: {

      'frm.titulo': async function (val){
        
        if (val){
          console.log(val)
          if (val.type=="MULTIPLE"){
            let response
            let opt={
                method: 'GET', 
                mode: 'cors'
            }

            response = await fetch(`${this.ROOT_API}titulos_items/?_filters={"tituloID":${val.value}}`, opt);
            if (response.ok){
              let r=await response.json()
              console.log("r-->",r)
              this.itemsTitulos=r.map(item => {
                return {
                  value:item.id,
                  text:item.descripcion 
                }
              })
            }

          }

        }
      },
    },

    methods: {
      importDatos (val ){
        console.log(val)
        this.items.push(...val)

      },
      async loadMultiple() {
                    let response
            let opt={
                method: 'GET', 
                mode: 'cors'
            }

            response = await fetch(`${this.ROOT_API}titulos_items/?_filters={"tituloID":${this.frm.titulo.value}}`, opt);
            if (response.ok){
              let r=await response.json()
              console.log("r-->",r)
              this.itemsTitulos=r.map(item => {
                return {
                  value:item.id,
                  text:item.descripcion 
                }
              })
            }
      },
      async loadTitulos(){
        let response
        let opt={
            method: 'GET', 
            mode: 'cors'
          }

        //INI TITULOS
        let p=this.categoriaID ? `?categoriaID=${this.categoriaID}` : ''
        response = await fetch(`${this.ROOT_API}cms/titulos/titulos_categorias${p}`, opt);
        if (response.ok){
          let r=await response.json()
          this.titulos=r.map(item => {
            return {
              value:item.id,
              text:item.descripcion,
              type:item.tipo
            }
          })
        }
        //FIN TITULOS
        

      },

      async initialize () {

        this.loadTitulos()

        let response
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        

        //INI FORMULARIO
        
       
        //FIN FORMULARIO
      },

      editItem (item){
        this.editedIndex = this.items.indexOf(item)
        Object.assign(this.editedItem, item)

        console.log("editedItem",this.editedItem)
        console.log(this.items[this.editedIndex])

        console.log("item-->",item)
        this.frm={
          id:item.id,
          disabled:true,
          titulo:{
            value:item.tituloID,
            text:item.descripcion,
            type:item.tipo,
          },
          valor1: item.tipo!="MULTIPLE" ? item.valor1 : {value:item.valor1_value,text:item.valor1},
          valor2: item.tipo=="SIMPLE" ?  item.valor2 : '',
          valor3: item.tipo=="SIMPLE" ?  item.valor3 : '',
          valor4: item.tipo=="SIMPLE" ?  item.valor4 : '',
          valor5: item.tipo=="SIMPLE" ?  item.valor5 : '',
        }
        
        

      },

      addItems (){
        this.editedItem.tituloID=this.frm.titulo.value
        this.editedItem.descripcion=this.frm.titulo.text
        this.editedItem.tipo=this.frm.titulo.type
        
        switch(this.editedItem.tipo) {
          case 'MULTIPLE':
            // code block
            this.editedItem.valor1_value=this.frm.valor1.value
            this.editedItem.valor1 =this.frm.valor1.text
            this.editedItem.valor2 =this.frm.valor2 || ''
            this.editedItem.valor3 =this.frm.valor3 || ''
            this.editedItem.valor4 =this.frm.valor4 || ''
            this.editedItem.valor5 =this.frm.valor5 || ''
            break;
          case 'SIMPLE':
          case 'LOGICO':
            // code block
            this.editedItem.valor1_value=0
            this.editedItem.valor1 =this.frm.valor1
            this.editedItem.valor2 =this.frm.valor2 || ''
            this.editedItem.valor3 =this.frm.valor3 || ''
            this.editedItem.valor4 =this.frm.valor4 || ''
            this.editedItem.valor5 =this.frm.valor5 || ''
            break;
            // code block
        }


        if (this.editedIndex==-1){
          console.log("nuevo item")
          this.editedItem.id=0
          this.editedItem.accion="I"
          this.items.push(this.editedItem)
        }
        else {
          console.log("edit item")
          this.editedItem.accion=this.frm.id?"U":"I"
          
          this.items.splice(this.editedIndex,1,this.editedItem)
        }
        this.frm=Object.assign({},this.default)
        this.editedItem={}
        this.editedIndex=-1
      },

      removeItem (item) {
        if (confirm('Seguro que desea eliminar el item seleccionado?')){
          let index = this.items.indexOf(item)
          if (item.id!=0){
            console.log("DELETE LOGICO")
            item.accion="D"
            //this.editedIndex = this.items.indexOf(item)
            this.items[index]=Object.assign({}, item)
          }
          else {
            console.log("DELETE")
            this.items.splice(index,1)
          }
        }
      },

      send () {
        //this.frm=Object.assign({},this.default)
        /*
        console.log("PASAJE DE PARAMETROS AL PADRE ",this.items)
        this.items.push({
          codigo: "NUEVO",
          marca_text: "NUEVA MACAR",
          marca_value: 2

        })
        this.$emit('send',this.items)
        */
      },



    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),
      
      Items () {
        let r
        //console.log("ITEMS",this.items)
        r=this.items.filter( item => item.accion!="D")
        return r
      },

      AddItems () {
          if (this.frm.titulo==undefined || this.frm.titulo=={}) return false
          //f ()
          console.log(this.frm)
          return true
      }
    },
  }
</script>

<style scoped>

</style>
